import styled, { css } from 'styled-components';
import _Image from 'next/image';

export type TitleProps = {
  $type: 'learn' | 'immerse' | 'communicate';
};

export const Card = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${theme.sz.s2} ${theme.sz.s6};

    @media (min-width: ${theme.sz.md}) {
      width: ${theme.sz.s};
      padding: ${theme.sz.s0};
    }
  `,
);

export const Title = styled.div<TitleProps>(
  ({ theme, $type }) => css`
    font-family: ${theme.DEPRECATED_ty.boing};
    font-weight: ${theme.DEPRECATED_ty.bold};
    font-size: ${theme.sz.s8};

    ${
      $type === 'learn' &&
      css`
        color: ${theme.co.success40};
      `
    }

    ${
      $type === 'immerse' &&
      css`
        color: ${theme.co.tertiary50};
      `
    }

    ${
      $type === 'communicate' &&
      css`
        color: ${theme.co.error60};
      `
    }

    @media (min-width: ${theme.sz.md}) {
      font-size: ${theme.DEPRECATED_ty.displaySmall};
    }
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    text-align: center;
    font-size: ${theme.DEPRECATED_ty.medium};
    line-height: ${theme.DEPRECATED_ty.large};
    padding: ${theme.sz.s2} ${theme.sz.s8};

    @media (min-width: ${theme.sz.md}) {
      padding: ${theme.sz.s0};
    }
  `,
);

export const Image = styled(_Image)`
  max-width: 100%;
  height: auto;
`;
